// import ReactGA from "react-ga4";
import ReactGA from "react-ga";
export const useAnalyticsPageView = () => {
  const pageView = (page: string) => {
    ReactGA.pageview(page);
    // ReactGA.send({ hitType: "pageview", page: page });
  };
  return pageView;
};
